export const LINE_BREAK_SEPARATOR = "\n";

export const INFO_BOX_CONTAINER = "zebrabi-info-container";

export const ANNOTATIONS_READ_MORE_URL = "https://help.zebrabi.com/kb/excel/annotation-layer-office-charts/";
